import MiniProductPackagesConnector from './miniProductPackages.props';
import MiniProductPackagesComponent from './miniProductPackages.component';

export default MiniProductPackagesConnector(MiniProductPackagesComponent);
